document.addEventListener("DOMContentLoaded", function () {
  function hasAnyShopifyFormDismissed() {
  // Sign Up成功后会新增786042-dismissed-after-submit字段, 判断是否Sign Up成功不再显示弹窗&按钮
    return Object.keys(localStorage).some(key =>
      key.endsWith("-dismissed-after-submit")
    );
  }
  if(hasAnyShopifyFormDismissed()){
    return;
  }
  // 监听 popup 内部 success
  function observePopupSuccess(embedNode) {
    if (!embedNode.shadowRoot) return;

    // 获取 shadow 内的 form 容器
    const formContainer = embedNode.shadowRoot.querySelector("#app-embed");
    if (!formContainer) {
      return;
    }

    const getShadowSuccess = () => {
      return (
        formContainer.querySelector('[data-current-step="success"]') ||
        formContainer.querySelector('[data-testid="banner-success"]')
      );
    };

    const formObserver = new MutationObserver((mutations, innerObserver) => {
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (!(n instanceof HTMLElement)) continue;
          // 先查节点本身
          let successEl =
            n.matches?.('[data-current-step="success"], [data-testid="banner-success"]')
              ? n
              : null;
          // Shadow DOM 内查找
          if (!successEl) successEl = getShadowSuccess();

          if (successEl) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "shopify_popup_signup_success",
              form_type: "popup",
              form_source: "shopify_forms",
            });

            innerObserver.disconnect(); // 成功后断开 observer
            return;
          }
        }
      }
    });

    // 监听 shadowRoot 内的 #app-embed 节点
    // formObserver.observe(formContainer, { childList: true, subtree: true });
    formObserver.observe(formContainer, { 
    childList: true, 
    subtree: true, 
    attributes: true, // 监听属性变化
    attributeFilter: ['data-current-step', 'data-testid'] // 只关心这两个
    });
  }

  // 监听 body 捕获 popup
  function observeBodyForPopup() {
    const bodyObserver = new MutationObserver((mutations, observer) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          const embedNode =
            node.tagName?.toLowerCase() === "shopify-forms-embed"
              ? node
              : node.querySelector?.("shopify-forms-embed");

          if (embedNode) {
            observer.disconnect(); // 找到 popup 后关闭 body 监听
            observePopupSuccess(embedNode); // 监听 popup 成功
          }
        }
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  // 启动 body 监听
  observeBodyForPopup();
});
